import { render, staticRenderFns } from "./RouletteUserList.vue?vue&type=template&id=982a0792&"
import script from "./RouletteUserList.vue?vue&type=script&lang=js&"
export * from "./RouletteUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports